import { guardString } from "../strings";

type DiffMap = Array<{
	key: string;
	oldValue: string | number | boolean | null;
	newValue: string | number | boolean | null;
}>;

/**
 * This function compares two objects and returns the differences between them.
 * @param _old
 * @param _new
 * @returns
 */
export function getAuditUpdateDiff<T extends object>(__old: unknown, __new: unknown) {
	const _old = __old as T;
	const _new = __new as T;
	if (!_old || !_new) return [];
	const allKeys = new Set<string>([...Object.keys(_old), ...Object.keys(_new)]);
	const diffMap: DiffMap = [];
	for (const key of allKeys) {
		const ignore = skip(key);
		if (ignore) continue;
		const oldValue = guardValue(_old[key as keyof T]);
		const newValue = guardValue(_new[key as keyof T]);

		if (oldValue !== newValue) {
			diffMap.push({
				key,
				newValue,
				oldValue,
			});
		}
	}

	return diffMap;
}

function skip(key: string) {
	if (key === "id") return true;
	if (key === "updatedAt") return true;
	if (key === "updatedBy") return true;
}

function guardValue(value: unknown): string | number | null {
	if (value === null) return "null";
	if (typeof value === "string") return value;
	if (typeof value === "number") return value;
	if (typeof value === "boolean") return value ? "true" : "false";
	return guardString(value);
}
